import React, { useEffect } from 'react';
import './Stake.scss';
import Header from '../Header';
import Footer from '../Footer';
import TelegramPopup from '../../Common/TelegramPopup/TelegramPopup';
import stakeMascotImage from '../../../assets/radixandgreenmonster.png'; // Assuming you save the image here

const Stake = () => {
  // Reset scroll position when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="stake-page">
      <Header />

      <main className="stake-content">
        <section className="stake-hero-section">
          <div className="container">
            <h1>PROOF OF <span className="dcks-highlight">$DCKS</span></h1>
            <p className="subtitle">Stake Your $REDDICKS. Earn Passive Income. No Risk, Just Rewards.</p>
            <a 
              href="#stake-widget" // Link to the widget section
              className="cta-button pulse-button" 
            >
              Stake Now & Earn
            </a>
          </div>
        </section>

        <section className="what-is-staking-section">
          <div className="container">
            <h2 className="section-title">What is Staking $REDDICKS?</h2>
            <div className="info-content">
              <div className="info-text">
                <p>Think of staking like putting your $REDDICKS tokens to work in a high-yield savings account, but way cooler and powered by the Radix network!</p>
                <p>Instead of just holding your tokens, you lock them up (stake them) in a special contract on DeFiPlaza. This doesn't mean you lose access forever – you can literally unstake them whenever you want.</p>
                <p>Staking your $REDDICKS helps ensure token price stability and clearly demonstrates the community's trust to newcomers. By participating, you not only strengthen the platform but are also rewarded with weekly $REDDICKS distributions, passively growing your holdings.</p>
              </div>
              <div className="info-image floating-image">
                {/* Integrate the provided image here */}
                <img src={stakeMascotImage} alt="Reddicks Staking Meme" />
              </div>
            </div>
          </div>
        </section>

        <section className="benefits-section">
          <div className="container">
            <h2 className="section-title">Why Stake Your $DCKS?</h2>
            <div className="benefits-grid">
              <div className="benefit-card">
                <div className="benefit-icon earn"></div>
                <h3>Earn Passive Income</h3>
                <p>Generate rewards automatically just by holding and staking your tokens. Your $REDDICKS work for you, 24/7.</p>
              </div>
              
              <div className="benefit-card">
                <div className="benefit-icon risk-free"></div>
                <h3>Zero Principal Risk</h3>
                <p>Unlike liquidity providing, staking $REDDICKS involves no risk of losing your initial tokens. Your staked amount remains safe.</p>
              </div>
              
              <div className="benefit-card">
                <div className="benefit-icon no-il"></div>
                <h3>No Impermanent Loss</h3>
                <p>Forget complex calculations. Staking $REDDICKS means you're immune to impermanent loss, ensuring your rewards are straightforward.</p>
              </div>
              
              <div className="benefit-card">
                <div className="benefit-icon support"></div>
                <h3>Support the Project</h3>
                <p>Staking helps secure the token ecosystem and shows your long-term commitment to the success of Reddicks.</p>
              </div>
            </div>
          </div>
        </section>

        <section id="stake-widget" className="staking-widget-section">
          <div className="container">
            <h2 className="section-title">Stake Your $REDDICKS Now</h2>
            <p className="widget-intro">
              Use the secure DeFi Plaza widget below to stake your tokens directly. Connect your Radix wallet, choose the amount, and start earning rewards!
            </p>
            <div className="widget-container">
              <iframe 
                title="staking-widget" 
                src="https://radix.defiplaza.net/widget/staking/resource_rdx1t42hpqvsk4t42l6aw09hwphd2axvetp6gvas9ztue0p30f4hzdwxrp?theme=blue" 
                width="100%" 
                scrolling="no" 
                height="1000px" // Adjust height as needed
                style={{ border: 0, margin: '0 auto', display: 'block', maxWidth: '960px', minWidth: '375px', colorScheme: 'normal' }}
              />
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <TelegramPopup />
    </div>
  );
};

export default Stake; 